import React, { createContext, useContext, useEffect, useState } from 'react';
import axiosInstance from '../axiosInstance';
const UserContext = createContext();

// export const UserProvider = ({ children }) => {
//   const [userData, setUserData] = useState();

//   const setUser = (user) => {
//     setUserData(user);
//   };



//   return (
//     <UserContext.Provider value={{ userData, setUser }}>
//       {children}
//     </UserContext.Provider>
//   );
// };

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState(() => {
    // Retrieve the user data from localStorage on initial load
    const savedUserData = localStorage.getItem('userData');
    return savedUserData ? JSON.parse(savedUserData) : null;
  });

  const setUser = (user) => {
    // Save user data in state and localStorage
    setUserData(user);
    localStorage.setItem('userData', JSON.stringify(user));
  };

  return (
    <UserContext.Provider value={{ userData, setUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  return useContext(UserContext);
};





